// Generated by pnpm agent:tools from locally maintained provider definitions.
export default [
  "dataforseo_keyword_ideas",
  "dataforseo_search_volumes",
  "dingtalk_read_document",
  "dingtalk_read_table",
  "dingtalk_send_message",
  "exa_agent",
  "exa_answer",
  "exa_find_similar_links",
  "exa_get_contents",
  "exa_search",
  "feishu_read_document",
  "feishu_send_message",
  "firecrawl_agent",
  "firecrawl_batch_scrape_status",
  "firecrawl_parse",
  "firecrawl_scrape",
  "firecrawl_search",
  "firecrawl_batch_scrape",
  "firecrawl_cancel_crawl",
  "firecrawl_crawl_status",
  "firecrawl_crawl",
  "firecrawl_credit_usage",
  "firecrawl_extract_status",
  "firecrawl_extract",
  "firecrawl_map",
  "parallel_deep_research",
  "parallel_extract",
  "parallel_search",
  "serpapi_google_search",
  "serpapi_youtube_video_transcript",
  "serpapi_youtube_data",
  "serper_search",
  "wecom_read_document",
  "wecom_send_message"
]
